import React from 'react';
import { motion } from 'framer-motion';
export function Board() {
  const boardMembers = [{
    name: 'Brannon Hampton',
    title: 'President',
    image: 'https://www.goodyearaz.gov/home/showpublishedimage/21530/638233913082230000',
    bio: "Goodyear City Council Vice Mayor and Arizona financial advisor committed to growing the region's business community."
  }, {
    name: 'Thomas Schoaf',
    title: 'Vice President',
    image: 'https://litchfieldpark.gov/ImageRepository/Document?documentID=8738',
    bio: 'Mayor of Litchfield Park and longtime Arizona attorney with deep roots in business law and community leadership.'
  }, {
    name: 'Jennifer Polansky',
    title: 'Treasurer',
    image: 'https://www.JenniferPolansky.com/briefcase/139926_111202572910AM88789.jpg',
    bio: 'Arizona REALTOR®, entrepreneur, community builder, and Rotarian serving on the West Valley Regional Chamber Board who founded the Estrella Community Garden.'
  }, {
    name: 'Joseph Pizzillo',
    title: 'Board Member',
    image: 'https://www.goodyearaz.gov/home/showpublishedimage/728/638721164647930000',
    bio: 'Mayor of Goodyear and seasoned finance professional with 30 years of experience in government budgeting and economic development.'
  }, {
    name: 'Mike Pineda',
    title: 'Board Member',
    image: 'https://cdn.magicpatterns.com/uploads/javWwyTYw4GySrMNVUrDYt/pasted-image.jpg',
    bio: 'Mayor of Avondale, lifelong Arizona resident, and Business Program Director at Estrella Mountain Community College with a deep background in small business development and entrepreneurship.'
  }, {
    name: 'Tamara Jamison',
    title: 'Board Member',
    image: 'https://cdn.magicpatterns.com/uploads/pYoTEzGXQ7kSZQQ617hgKv/image.png',
    imagePosition: 'object-[50%_12%]',
    bio: 'CORE Construction leader who partners with Arizona cities and towns on the infrastructure and community projects that support responsible local growth.'
  }];
  return <section id="leadership" className="py-24 bg-pac-sand" data-id="element-8" data-mp="hwivm9w5hjp5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="huy4ku91oiw1">
        <div className="text-center mb-16" data-id="element-10" data-mp="cyr6toqsydp6">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-11" data-mp="8wcmf07hj5vs">
            Board of Directors
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-12" data-mp="15mveugwuj2v1">
            Municipal and community leaders committed to Arizona&apos;s cities and towns.
          </p>
          <div className="w-24 h-1 bg-pac-red mx-auto mt-6" data-id="element-13" data-mp="wlx5dj3n2352" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-14" data-mp="wo1j0srcagij">
          {boardMembers.map((member, index) => <motion.article key={member.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200" data-id="element-15" data-mp="3hbwe3usicg8q" data-mpi={index}>
              <div className="aspect-[4/5] w-full overflow-hidden bg-slate-100" data-id="element-16" data-mp="1ws0vby5uch2b">
                <img src={member.image} alt={member.name} className={`w-full h-full object-cover ${member.imagePosition ?? 'object-[center_20%]'} hover:scale-105 transition-transform duration-500`} data-id="element-17" data-mp="20ufgwq0w9uxa" />
              </div>
              <div className="p-6 text-center" data-id="element-18" data-mp="2fj1uonavieme">
                <h3 className="font-serif text-2xl font-bold text-pac-navy mb-1" data-id="element-19" data-mp="2kjzbavg8j0ls">{member.name}</h3>
                <p className="text-pac-red font-bold text-sm uppercase tracking-wider mb-4" data-id="element-20" data-mp="2ol1dnl5g7srz">{member.title}</p>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-21" data-mp="q66qw6wghqz0">{member.bio}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}